<template>
  <div :class="`color-selector ${centered ? 'centered-content' : ''}`">
    <div :class="`${hasTransparencyInSelectedColor ? 'hide-dot' : ''}`">
      <compact-color-picker
          v-model="selectedColor"
          :palette="palette"/>
    </div>
    <popover>
      <div data-role="trigger">
        <span role="button"
              class="vc-compact-color-item"
              :style="{background: selectedColor.hex8}">
          <div class="vc-compact-dot" v-show="!isSelectedColorInPalette"></div>
        </span>
      </div>

      <template slot="popover">
        <sketch-picker v-model="selectedColor" :presetColors="palette">
        </sketch-picker>
      </template>
    </popover>
  </div>
</template>
<script>
import VueColor from 'vue-color'
import c from '@/tools/colors/colors'

export default {
  name: 'color-selector',

  props: {
    defaultColor: {
      type: Object,
      required: false,
      default: function () {
        return c.getHexModuleColor('reaInfADI')
      }
    },

    customPalette: {
      type: Array,
      required: false,
      default: function () { return [] }
    },

    centered: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: function () {
    return {
      defaultPalette: c.mapPalettes.modules,
      selectedColor: this.defaultColor
    }
  },

  watch: {
    selectedColor: function () {
      this.$emit('input', this.selectedColor)
    },

    defaultColor: function () {
      this.selectedColor = this.defaultColor
    }
  },

  computed: {
    palette: function () {
      const customPalette = this.customPalette
      if (customPalette.length === 0) {
        return this.getColorList(this.defaultPalette)
      }

      return this.getColorList(this.customPalette)
    },

    hasTransparencyInSelectedColor: function () {
      const alpha = this.selectedColor.a
      return alpha != null && alpha < 1
    },

    isSelectedColorInPalette: function () {
      if (this.hasTransparencyInSelectedColor) {
        return false
      }

      const palette = this.palette
      for (let i = 0; i !== palette.length; ++i) {
        const c = palette[i]
        if (c === this.selectedColor.hex) {
          return true
        }
      }
      return false
    }
  },

  methods: {
    getColorList: function (palette) {
      const result = []
      for (let i = 0; i < palette.length; i++) {
        result.push(palette[i].hex)
      }
      return result
    }
  },

  components: {
    'compact-color-picker': VueColor.Compact,
    'sketch-picker': VueColor.Sketch
  }
}

</script>
<style scoped>
.color-selector {
  padding: 2px;
  display: flex;
  justify-content: flex-start;
  width: 100%;

  a {
    padding-right: 5px;
  }

  .vc-compact {
    box-shadow: none;
    width: auto;
    border-right: 1px solid #cccccc;
    border-radius: 0px;
    padding-top: 3px;
    padding-left: 0px;
  }

  >>> .vc-compact-colors > li {
    border: 1px solid #666666;
  }

  >>> .vc-compact-dot {
    border: 1px solid #666666;
    top: 3px;
    bottom: 3px;
    left: 3px;
    right: 3px;
  }

  .hide-dot {
    >>> .vc-compact-dot {
      display: none;
    }
  }

  div > span.vc-compact-color-item {
    border: 1px solid #666666;
    margin-top: 3px;
    margin-right: 0px;
    margin-left: 5px;
  }
}

.centered-content {
  justify-content: center;
}

</style>
